// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  margin-top: 8px;
  width: calc(100% - 60px);
  overflow: hidden;
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/field/fieldB.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;AACJ","sourcesContent":["button {\n    margin-top: 8px;\n    width: calc(100% - 60px);\n    overflow: hidden;\n    white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
